import { RouteConfig } from 'vue-router';

import { settingEditRoute } from './setting/settingEdit.route';
import { settingListRoute } from './setting/settingList.route';

export const settingContainerRoute: RouteConfig = {
  path: 'setting',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [settingEditRoute, settingListRoute],
  meta: {
    breadcrumb: {
      title: 'Ustawienia',
      name: 'settingList'
    },
    config: {
      title: 'Ustawienia',
      name: 'settingList',
      icon: 'fa-cog',
      permissions: ['SETTING.LIST']
    }
  }
};
